/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GetProductBrandsParams,
  HTTPValidationError,
  ProductBrandCreate,
  ProductBrandRead,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to create a new product_brand.
 * @summary Create Product Brand
 */
export const createProductBrand = (
  productBrandCreate: ProductBrandCreate,
  signal?: AbortSignal,
) => {
  return customInstance<ProductBrandRead>({
    url: `/api/product_brand/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: productBrandCreate,
    signal,
  });
};

export const getCreateProductBrandMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProductBrand>>,
    TError,
    { data: ProductBrandCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createProductBrand>>,
  TError,
  { data: ProductBrandCreate },
  TContext
> => {
  const mutationKey = ["createProductBrand"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createProductBrand>>,
    { data: ProductBrandCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createProductBrand(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateProductBrandMutationResult = NonNullable<
  Awaited<ReturnType<typeof createProductBrand>>
>;
export type CreateProductBrandMutationBody = ProductBrandCreate;
export type CreateProductBrandMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Product Brand
 */
export const useCreateProductBrand = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createProductBrand>>,
      TError,
      { data: ProductBrandCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createProductBrand>>,
  TError,
  { data: ProductBrandCreate },
  TContext
> => {
  const mutationOptions = getCreateProductBrandMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get many product_brands.

Results are paginated.
 * @summary Get Product Brands
 */
export const getProductBrands = (
  params?: GetProductBrandsParams,
  signal?: AbortSignal,
) => {
  return customInstance<ProductBrandRead[]>({
    url: `/api/product_brand/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetProductBrandsQueryKey = (
  params?: GetProductBrandsParams,
) => {
  return ["api", "product_brand", ...(params ? [params] : [])] as const;
};

export const getGetProductBrandsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductBrands>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetProductBrandsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductBrands>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetProductBrandsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getProductBrands>>
  > = ({ signal }) => getProductBrands(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductBrands>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductBrandsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProductBrands>>
>;
export type GetProductBrandsQueryError = ErrorType<void | HTTPValidationError>;

export function useGetProductBrands<
  TData = Awaited<ReturnType<typeof getProductBrands>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetProductBrandsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductBrands>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductBrands>>,
          TError,
          Awaited<ReturnType<typeof getProductBrands>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProductBrands<
  TData = Awaited<ReturnType<typeof getProductBrands>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetProductBrandsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductBrands>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductBrands>>,
          TError,
          Awaited<ReturnType<typeof getProductBrands>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProductBrands<
  TData = Awaited<ReturnType<typeof getProductBrands>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetProductBrandsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductBrands>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Product Brands
 */

export function useGetProductBrands<
  TData = Awaited<ReturnType<typeof getProductBrands>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetProductBrandsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductBrands>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetProductBrandsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to check for duplicate product brands.
 * @summary Check Create Product Brand
 */
export const checkCreateProductBrand = (
  productBrandCreate: ProductBrandCreate,
  signal?: AbortSignal,
) => {
  return customInstance<ProductBrandRead[]>({
    url: `/api/product_brand/check-create`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: productBrandCreate,
    signal,
  });
};

export const getCheckCreateProductBrandMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkCreateProductBrand>>,
    TError,
    { data: ProductBrandCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checkCreateProductBrand>>,
  TError,
  { data: ProductBrandCreate },
  TContext
> => {
  const mutationKey = ["checkCreateProductBrand"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checkCreateProductBrand>>,
    { data: ProductBrandCreate }
  > = (props) => {
    const { data } = props ?? {};

    return checkCreateProductBrand(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CheckCreateProductBrandMutationResult = NonNullable<
  Awaited<ReturnType<typeof checkCreateProductBrand>>
>;
export type CheckCreateProductBrandMutationBody = ProductBrandCreate;
export type CheckCreateProductBrandMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Check Create Product Brand
 */
export const useCheckCreateProductBrand = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof checkCreateProductBrand>>,
      TError,
      { data: ProductBrandCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof checkCreateProductBrand>>,
  TError,
  { data: ProductBrandCreate },
  TContext
> => {
  const mutationOptions = getCheckCreateProductBrandMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get an product_brand by ID.
 * @summary Get Product Brand
 */
export const getProductBrand = (
  productBrandId: number,
  signal?: AbortSignal,
) => {
  return customInstance<ProductBrandRead>({
    url: `/api/product_brand/${productBrandId}`,
    method: "GET",
    signal,
  });
};

export const getGetProductBrandQueryKey = (productBrandId?: number) => {
  return ["api", "product_brand", productBrandId] as const;
};

export const getGetProductBrandQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductBrand>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  productBrandId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductBrand>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetProductBrandQueryKey(productBrandId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductBrand>>> = ({
    signal,
  }) => getProductBrand(productBrandId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!productBrandId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductBrand>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductBrandQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProductBrand>>
>;
export type GetProductBrandQueryError = ErrorType<void | HTTPValidationError>;

export function useGetProductBrand<
  TData = Awaited<ReturnType<typeof getProductBrand>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  productBrandId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductBrand>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductBrand>>,
          TError,
          Awaited<ReturnType<typeof getProductBrand>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProductBrand<
  TData = Awaited<ReturnType<typeof getProductBrand>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  productBrandId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductBrand>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductBrand>>,
          TError,
          Awaited<ReturnType<typeof getProductBrand>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProductBrand<
  TData = Awaited<ReturnType<typeof getProductBrand>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  productBrandId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductBrand>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Product Brand
 */

export function useGetProductBrand<
  TData = Awaited<ReturnType<typeof getProductBrand>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  productBrandId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductBrand>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetProductBrandQueryOptions(productBrandId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to update an product_brand by ID.
 * @summary Update Product Brand
 */
export const updateProductBrand = (
  productBrandId: number,
  productBrandCreate: ProductBrandCreate,
) => {
  return customInstance<ProductBrandRead>({
    url: `/api/product_brand/${productBrandId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: productBrandCreate,
  });
};

export const getUpdateProductBrandMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProductBrand>>,
    TError,
    { productBrandId: number; data: ProductBrandCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProductBrand>>,
  TError,
  { productBrandId: number; data: ProductBrandCreate },
  TContext
> => {
  const mutationKey = ["updateProductBrand"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProductBrand>>,
    { productBrandId: number; data: ProductBrandCreate }
  > = (props) => {
    const { productBrandId, data } = props ?? {};

    return updateProductBrand(productBrandId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProductBrandMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProductBrand>>
>;
export type UpdateProductBrandMutationBody = ProductBrandCreate;
export type UpdateProductBrandMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Product Brand
 */
export const useUpdateProductBrand = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateProductBrand>>,
      TError,
      { productBrandId: number; data: ProductBrandCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateProductBrand>>,
  TError,
  { productBrandId: number; data: ProductBrandCreate },
  TContext
> => {
  const mutationOptions = getUpdateProductBrandMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to delete an product_brand by ID.
 * @summary Delete Product Brand
 */
export const deleteProductBrand = (productBrandId: number) => {
  return customInstance<unknown>({
    url: `/api/product_brand/${productBrandId}`,
    method: "DELETE",
  });
};

export const getDeleteProductBrandMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProductBrand>>,
    TError,
    { productBrandId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProductBrand>>,
  TError,
  { productBrandId: number },
  TContext
> => {
  const mutationKey = ["deleteProductBrand"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProductBrand>>,
    { productBrandId: number }
  > = (props) => {
    const { productBrandId } = props ?? {};

    return deleteProductBrand(productBrandId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteProductBrandMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteProductBrand>>
>;

export type DeleteProductBrandMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Delete Product Brand
 */
export const useDeleteProductBrand = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteProductBrand>>,
      TError,
      { productBrandId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteProductBrand>>,
  TError,
  { productBrandId: number },
  TContext
> => {
  const mutationOptions = getDeleteProductBrandMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
